export const SOCKET_EVENTS = {
	// ACCESS_CONTROL_EVENTS
	GRANTED_PERMISSION: 'prmGranted',
	REVOKED_PERMISSION: 'prmRevoked',
	ACCESS_EVENT: 'accessEvent',
	KIOSK_EVENT: 'kioskEvent',
	//DEVICE_EVENTS
	DEVICE_EVENT: 'device',
	ADD_DEVICE_EVENT: 'addDevice',
	//BOOKINGS_EVENTS
	LOCKER_BOOKING_CREATED: 'lockerBookingCreated',
	LOCKER_BOOKING_DELETED: 'lockerBookingDeleted',
	LOCKER_BOOKED_BY_PERSON: 'lockerBookedByPerson',
	LOCKER_RELEASED_BY_PERSON: 'lockerReleasedByPerson',
	// A room/space booking changed server-side (created/approved/rejected/cancelled/rescheduled/no-show).
	// The operator calendar + approvals queue re-hydrate live. Org-scoped hint: { orgID, bookingID, action }.
	BOOKING_CHANGED: 'booking:changed',

	//SETTINGS_EVENTS
	SETTING_ENABLE_ACCESS_CONTROL: 'settingEnableAccessControl',
	SETTING_DISABLE_ACCESS_CONTROL: 'settingDisableAccessControl',
	SETTING_ENABLE_MODULE_LOCKER: 'settingEnableModuleLocker',
	SETTING_DISABLE_MODULE_LOCKER: 'settingDisableModuleLocker',

	//PERSON_EVENTS
	PERSON_ADDED: 'personAdded',
	PERSON_UPDATED: 'personUpdated',
	PERSON_DELETED: 'personDeleted',
	PERSON_ENABLED: 'personEnabled',
	PERSON_DISABLED: 'personDisabled',

	//LOGGING_EVENTS
	LOG_ACCESS_EVENT: 'log:access:event',
	LOG_SYNC_COMPLETE: 'log:sync:complete',

	//NOTIFICATION_EVENTS (D5a Alert Hub) — emitted to the recipient's person:<fbUID> room
	NOTIFICATION_NEW: 'notification:new', // a new in-app notification/alert row landed
	ALERT_UPDATED: 'alert:updated', // an existing row changed state (resolved/snoozed/read) — reserved

	// SYNC_EVENTS
	SYNC_PROGRESS: 'sync:progress',
	SYNC_COMPLETE: 'sync:complete',
	SYNC_ERROR: 'sync:error',

	// ORG SETTING changed server-side (integration sync-in-progress flags) so the
	// "syncing…" indicator reflects start/finish live. Payload: { orgID, defaultSettingID, value }
	ORG_SETTING_UPDATED: 'setting:updated',

	// BULK_CREDENTIAL_EVENTS
	CREDENTIAL_BULK_PROGRESS: 'credential:bulk:progress',
	CREDENTIAL_BULK_COMPLETE: 'credential:bulk:complete',
	CREDENTIAL_BULK_ERROR: 'credential:bulk:error',

	// CREDENTIAL PROPAGATION — single signal. Means "propagation state changed for this
	// org — refetch GET /credentials/propagation" (payload { orgID }). The DB snapshot is
	// the source of truth. See docs/design/credential-propagation-signal-refetch-rfc.md.
	CREDENTIAL_PROPAGATION_CHANGED: 'credential:propagation:changed',

	// FEATURE_FLAG_EVENTS — a dev-controlled flag changed (org override or platform default).
	FEATURE_FLAG_CHANGED: 'featureFlagChanged'
};
